import { render, staticRenderFns } from "./AcordoModal.vue?vue&type=template&id=8fc8c88e"
import script from "./AcordoModal.vue?vue&type=script&lang=js"
export * from "./AcordoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports